import { registerDafCardTypeHandler } from '../pledges/daf-card-type-handlers.js';
import { opModal, openPaymentIsOnline } from './dom.js';
import { syncCvvFieldForCardType } from '../../shared/field-validation.js';

let openPaymentDafCardType = 'credit';

export function getOpenPaymentDafCardType() {
    return openPaymentDafCardType;
}

export function setOpenPaymentDafCardType(cardType) {
    if (openPaymentDafCardType && openPaymentDafCardType !== cardType) {
        opModal().find('#open_payment_card, #open_payment_cvv2, #open_payment_expiry_month, #open_payment_expiry_year, #open_payment_avs_zip').val('');
    }
    openPaymentDafCardType = cardType;
    const p = '#open_payment_';
    if (cardType === 'credit') {
        const ptype = String(opModal().find(p + 'payment_type').val() || '');
        const mustRequire = openPaymentIsOnline() && ptype === 'new';
        opModal().find(p + 'avs_zip').prop('required', mustRequire);
        syncCvvFieldForCardType(opModal().find(p + 'cvv2'), 'credit');
        if (!mustRequire) {
            opModal().find(p + 'cvv2').prop('required', false);
        }
    } else {
        opModal().find(p + 'avs_zip').prop('required', false);
        syncCvvFieldForCardType(opModal().find(p + 'cvv2'), cardType);
    }
}

export function registerOpenPaymentDafCardTypeHandler() {
    registerDafCardTypeHandler('open_payment_', setOpenPaymentDafCardType);
}
